<template>
    <ion-item>
        <ion-label class="ion-text-wrap">
            <h2>Multi Box
                <ion-text v-if="multi" color="success">On</ion-text>
                <ion-text v-else color="danger">Off</ion-text>
            </h2>
            <p class="ion-text-justify">
                Set up multiple boxes of the same type?
            </p>
        </ion-label>
        <ion-toggle slot="end" :value="true" @ionChange="multi = $event.target.checked" :checked="multi" />
    </ion-item>
</template>

<script>
import {IonItem, IonLabel, IonToggle,IonText} from '@ionic/vue';
import {computed} from 'vue';

export default {
    name: "MultiBoxToggle",
    emits: ['update:modelValue'],
    props: ['modelValue'],
    components: {
        IonItem,
        IonText,
        IonToggle,
        IonLabel
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const multi = computed({
            get: () => props.modelValue,
            set: (value) => {
                console.log("Emitting ", value);
                emit('update:modelValue', value);
            }
        });
        return {multi};
    }
}
</script>

<style scoped>

</style>
